/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Restore job status. For an explanation of statuses, see [Restore Job Statuses](/docs/user-guide/restoring/restore-job-statuses). 
*/
export enum JobStatus {
  JOB_UNSPECIFIED = 'JOB_UNSPECIFIED',
  JOB_PENDING = 'JOB_PENDING',
  JOB_RUNNING = 'JOB_RUNNING',
  JOB_COMPLETED = 'JOB_COMPLETED',
  JOB_FAILED = 'JOB_FAILED',
  JOB_PARTIAL = 'JOB_PARTIAL'
}
